import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { WebhookEndpoint } from 'src/features/webhook-endpoints/utils/types';
import { WebhookEndpointSchemaValues } from 'src/features/webhook-endpoints/utils/formSchema';

const RESOURCE = '/webhooks/webhook-endpoints/:endpointId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    endpointId: string;
    data: Partial<WebhookEndpointSchemaValues>;
}

const mutationFn = ({ endpointId, data }: DTO): Promise<WebhookEndpoint> => {
    return axios.patch(formatResourcePath(RESOURCE, { endpointId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as usePatchWebhookEndpoint };
